<div class="login_form">

    <div class="logo">
        <img src="../../../../../assets/images/logo/flowtrics_logo.png">
    </div>

    <div class="title">Please wait a moment while we process your request. Thank you for your patience!</div>   
  
    <span class="loader">L &nbsp; ading</span>

</div>

<!-- <div class="progress-loader" *ngIf="spinner">
    <div class="lds-ripple" ><div></div><div></div></div>
  </div> -->
